import {
  Box,
  Card,
  Chip,
  Container,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import Button from "../base/Button";
import { Add } from "@mui/icons-material";
import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import TableActions from "../base/TableActions";
import DataGridTable from "../base/DataGridTable";
import ConnectionSetup from "./ConnectionSetup";
import { useDispatch, useSelector } from "../../store";
import { getHubInstances } from "../../slices/hub";

interface Props {}

const SecurityHub: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { hubList } = useSelector((store) => store.hub);
  const [modal, setModal] = useState(false);
  const hubs = [
    {
      id: 1,
      abv: "T",
      title: "Total Hubs",
      color: theme.palette.primary.main,
      total: hubList.length,
    },
    {
      id: 2,
      abv: "C",
      title: "Connected",
      color: theme.palette.success.main,
      total: hubList.filter((h) => h.status.id === 1).length,
    },
    {
      id: 3,
      abv: "P",
      title: "Pending Connection",
      color: theme.palette.tertiary.main,
      total: hubList.filter((h) => h.status.id === 2).length,
    },
    {
      id: 4,
      abv: "F",
      title: "Failed",
      color: theme.palette.error.main,
      total: hubList.filter((h) => h.status.id === 3).length,
    },
  ];

  useEffect(() => {
    dispatch(getHubInstances());
  }, [dispatch]);

  const columns: GridColDef[] = [
    {
      field: "hubName",
      headerName: "Hub Name",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "region",
      headerName: "Region",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "status",
      headerName: "Status",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
      renderCell: (params) => <>{params.value}</>,
    },
    {
      field: "connections",
      headerName: "Connections",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "lastUpdated",
      headerName: "Last Updated",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      disableExport: true,
      renderCell: (params) => <>{params.value}</>,
      headerClassName: "header",
    },
  ];

  //make model for connection and hub and make slice and move row and hub to slice

  const rows = hubList.map((row) => {
    let rowObject = {
      id: row.id,
      hubName: row.name,
      region: row.region,
      status: (
        <Chip
          label={row.status.value}
          size="small"
          sx={{
            color: theme.palette.primary.contrastText,
            backgroundColor:
              row.status.id === 1
                ? theme.palette.success.main
                : row.status.id === 2
                ? theme.palette.tertiary.main
                : theme.palette.error.main,
          }}
        />
      ),
      connections: row.connections,
      lastUpdated: moment(row.lastUpdated).format("YYYY-MM-DD hh:mm"),
      actions: (
        <TableActions
          id={row.id}
          handleEdit={() => {}}
          handleDelete={() => {}}
        />
      ),
    };
    return rowObject;
  });

  return (
    <Container>
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={{ md: "space-between", xs: "center" }}
        alignItems={"center"}
        flexWrap={"wrap"}
        gap={2}
        pb={4}
      >
        {hubs.map((h) => (
          <Card
            key={h.id}
            sx={{
              padding: 2,
              width: 250,
            }}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={2}
            >
              <Box
                sx={{
                  padding: 2,
                  width: 50,
                  height: 50,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: h.color,
                  borderRadius: "5px",
                }}
              >
                {/* //try light color from primary */}
                <Typography sx={{ color: "white" }} fontWeight={600}>
                  {h.abv}
                </Typography>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                <Typography variant="body2">{h.title}</Typography>
                <Typography variant="h3">{h.total}</Typography>
              </Box>
            </Box>
          </Card>
        ))}
      </Box>
      <Paper
        sx={{
          paddingY: 3,
          paddingX: { xs: 2, md: 5 },
          marginBottom: 5,
          // backgroundColor: theme.palette.background.default,
        }}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          pb={2}
        >
          <Box>
            <Typography fontWeight={"bold"} variant="h4">
              Security Hub Instances
            </Typography>
          </Box>
          <Box>
            <Button
              icon={<Add />}
              label="Add New Hub"
              onClick={() => setModal(true)}
              variant="contained"
            />
          </Box>
        </Box>
        {/* <Card sx={{}}> */}
        <DataGridTable columns={columns} rows={rows} />
        {/* </Card> */}
      </Paper>
      <Modal
        open={modal}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ConnectionSetup onClose={() => setModal(false)} />
      </Modal>
    </Container>
  );
};

export default SecurityHub;
